import { ApiError } from '../api/client.js';

/**
 * The sentences for a refused family form - Add a family, Edit details and the
 * parent's own page - by the API's code, and which input each belongs under.
 * As Send again and Invite the other parent say them.
 */
const MESSAGES: Record<string, string> = {
  required: 'This is required.',
  too_long: 'This is too long.',
  invalid_date: 'That is not a date.',
  must_be_adult: 'An account holder must be 18 or over.',
  in_the_future: 'That date has not happened yet.',
  invalid_email: 'That is not an email address.',
  invalid_phone: 'That is not a phone number.',
  email_has_account: 'That email already has an account.',
  email_taken: 'Another family was invited at that email.',
  link_dead: 'This link no longer works.',
  not_invited: 'This family has signed up. The details are theirs now.',
};

const EMAIL_CODES = new Set(['email_has_account', 'email_taken']);

export function familyProblem(cause: unknown): { field: string; message: string } {
  if (!(cause instanceof ApiError)) return { field: '', message: 'That did not save. Try again.' };
  const field = cause.field ?? (EMAIL_CODES.has(cause.code) ? 'parent_email' : '');
  return { field, message: MESSAGES[cause.code] ?? 'That did not save. Try again.' };
}
